export default {
    init() {
        // JavaScript to be fired on archive pages

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
/* eslint-disable */
$('.js-products-slider__compare').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: '.js-compare-table-values',
    prevArrow: `<button type="button" class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" style="fill: #404ade;transform: rotate(180deg);">    <path d="M12,27h-2c-0.386,0-0.738-0.223-0.904-0.572s-0.115-0.762,0.13-1.062L17.708,15L9.226,4.633 c-0.245-0.299-0.295-0.712-0.13-1.062S9.614,3,10,3h2c0.3,0,0.584,0.135,0.774,0.367l9,11c0.301,0.369,0.301,0.898,0,1.267l-9,11 C12.584,26.865,12.3,27,12,27z"></path></svg></button>`,
    nextArrow: `<button type="button" class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" style="fill: #404ade;">    <path d="M12,27h-2c-0.386,0-0.738-0.223-0.904-0.572s-0.115-0.762,0.13-1.062L17.708,15L9.226,4.633 c-0.245-0.299-0.295-0.712-0.13-1.062S9.614,3,10,3h2c0.3,0,0.584,0.135,0.774,0.367l9,11c0.301,0.369,0.301,0.898,0,1.267l-9,11 C12.584,26.865,12.3,27,12,27z"></path></svg></button>`,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
})

$('.js-compare-table-values').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    asNavFor: '.js-products-slider__compare',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
})

$(".js-compare-table-values").on("afterChange", function (){
    $(this).find('.slick-active').removeClass('last');
    $(this).find('.slick-active:last').addClass('last');
})
/* eslint-enable */
